import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { MOCKUP_URL } from '../data/content';
export function FinalCta() {
  return <section className="w-full bg-volt py-16 text-ink sm:py-24" aria-labelledby="final-title" data-id="element-135" data-mp="19ez21e8mxa2p">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6" data-id="element-136" data-mp="19cmd2h4glzg5">
        <h2 id="final-title" className="font-display text-[40px] font-extrabold uppercase leading-[0.95] sm:text-6xl" data-id="element-137" data-mp="15bsormn3uimq">
          Stop letting mystery battery drains turn into random guesswork.
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-lg font-semibold sm:text-xl" data-id="element-138" data-mp="1t2yd6q742j8n">
          Build a more organized electrical diagnostic process starting today — a six-stage pathway, practical
          decision trees, and documentation tools for professional battery drain investigations.
        </p>
        <img src={MOCKUP_URL} alt="6 practical volumes plus 5 diagnostic bonuses" className="mx-auto mt-8 w-full max-w-2xl" data-id="element-139" data-mp="1x4jnc3s9gjf5" />
        <p className="mt-4 font-display text-3xl font-extrabold uppercase" data-id="element-140" data-mp="n6e2nf8ng5t7">6 Practical Volumes + 5 Diagnostic Bonuses</p>
        <p className="mt-1 text-lg font-bold" data-id="element-141" data-mp="s5gw02f9onlc">Get instant access for $27 USD</p>

        <div className="mt-8 rounded-3xl bg-ink p-5 sm:p-8" data-id="element-142" data-mp="x3ipzie8e7bl">
          <CtaButton label="Yes! Give me the complete diagnostic system" sub="Instant Digital Access • One-Time Payment • 7-Day Guarantee" data-id="element-143" data-mp="x64x5gx7mkta" />
          <div className="mt-6" data-id="element-144" data-mp="1646u9ldtotba">
            <Countdown data-id="element-145" data-mp="1b3jowsaxr4of" />
          </div>
        </div>
      </div>
    </section>;
}